import datapoints from './datapoints';
import setRowsFlagStateHelper from './helpers/setRowsFlagStateHelper';
import applyConversationFlagInListView from 'owa-mail-list-actions/lib/actions/triage/applyConversationFlag';
import { getApplyConversationActionContext, getRowIdsFromRowKeys } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { flagConversationService } from 'owa-mail-store/lib/services/flagConversationService';
import { handleServiceError } from 'owa-service-error';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { ApplyConversationFlagStateStoreUpdateActionName, } from 'owa-mail-store-actions';
import { userMailInteractionAction } from 'owa-mail-actions';
var SetConversationsFlagStateActionName = 'setConversationsFlagState';
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
var setConversationsFlagStateInternal = action(SetConversationsFlagStateActionName, datapoints.setConversationsFlagStateDatapoint)(function setConversationsFlagStateInternal(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var conversationIdStrings = getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    handleServiceError(SetConversationsFlagStateActionName, strings.errorFlaggingConversation, function () {
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return getApplyConversationActionContext(rowKey, tableViewId);
        });
        var flagType = {
            FlagStatus: flagStatusToApply,
        };
        // update list view store
        applyConversationFlagInListView(conversationRowKeys, flagType, tableViewId);
        // update reading pane store
        raiseAction(ApplyConversationFlagStateStoreUpdateActionName)(conversationIdStrings, flagType, tableViewId);
        var tableView = listViewStore.tableViews.get(tableViewId);
        // Do not specify folderId in search, so that action is global to the same conversation in all folders.
        var sourceFolderId = tableView.serverFolderId;
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagConversationService(conversationActionContexts, flagType, sourceFolderId);
    });
});
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
export default function setConversationsFlagState(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    setRowsFlagStateHelper(conversationRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        setConversationsFlagStateInternal(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
    });
}
//# sourceMappingURL=setConversationsFlagState.js.map